import React from 'react'
import ConactUsHeader from '../organisms/ContactUsHeader'
import ContactUsBody from '../organisms/ContactUsBody'
import Footer from '../organisms/Footer'
import useScrollToTop from '../../hooks/useScrollToTop'
const ContactUsPage = () => {
  useScrollToTop()
  return (
    <div className='bg-gray-100'>
      <ConactUsHeader />
      <ContactUsBody />
      <Footer />
    </div>
  )
}

export default ContactUsPage
